<template>
  <v-app app class="ma-0 pa-0" :class="($vuetify.theme.dark ? 'dark ' : 'light ') + (uiSettings.touchScreenMode ? 'scrollbarlarge' : 'scrollbarnormal')">
    <loading :background-color="$vuetify.theme.dark ? '#000' : '#FFF'" :color="$vuetify.theme.dark ? '#FFF' : '#000'" loader="bars" :active.sync="isUrlInvalid" :opacity="0.92" style="z-index: 99999999">
      <span slot="after"> <br />Невалиден линк! Моля, влезте в системата! </span>
    </loading>

    <ErrorComponent style="z-index: 99999999" />

    <loading :background-color="$vuetify.theme.dark ? '#000' : '#FFF'" :color="$vuetify.theme.dark ? '#FFF' : '#000'" loader="bars" :active.sync="isLoading" :opacity="0.95" style="z-index: 9998">
      <span slot="after">
        <br />
        {{ fp.loadingMessage }}
      </span>
    </loading>

    <loading :background-color="$vuetify.theme.dark ? '#000' : '#FFF'" :color="$vuetify.theme.dark ? '#FFF' : '#000'" loader="bars" :active.sync="fp.isSearchingForServer" :opacity="0.9">
      <span slot="after"> <br />Свързване със ZFPLabServer... </span>
    </loading>

    <loading :background-color="$vuetify.theme.dark ? '#000' : '#FFF'" :color="$vuetify.theme.dark ? '#FFF' : '#000'" loader="bars" :active.sync="fp.isSearchingForDevice" :opacity="0.9">
      <span slot="after"> <br />Свързване с фискалното устройство... </span>
    </loading>

    <v-dialog v-model="isInStatusMode">
      <Status />
    </v-dialog>

    <v-dialog v-model="isInDateTimeMode" v-if="isInDateTimeMode" persistent max-width="320px">
      <ProgDateTime />
    </v-dialog>

    <v-dialog v-model="isInQrScanMode" v-if="isInQrScanMode" :width="500" :max-width="500">
      <QRScanner :width="500" />
      <v-btn color="error" text fab @click="exitScannerMode()" style="position: absolute; top: 25px; right: 15px; z-index: 9999999">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-dialog>

    <v-dialog v-model="isInMoneyInOutMode" persistent :max-width="isOnMobile ? '320px' : '450px'">
      <MoneyInOut v-if="isInMoneyInOutMode" />
    </v-dialog>

    <v-dialog v-model="isInOperationsMode" persistent :max-width="isOnMobile ? '90vw' : '60vw'">
      <Operations />
    </v-dialog>

    <v-dialog v-model="isInSettingsMode" persistent v-if="isInSettingsMode" :max-width="isOnMobile ? '90vw' : '800px'">
      <Settings />
    </v-dialog>

    <v-dialog fullscreen v-model="isInProgArtMode" v-if="isInProgArtMode" persistent :max-width="$vuetify.breakpoint.name == 'md' ? '100%' : '80%'">
      <ProgArticle />
    </v-dialog>

    <v-dialog fullscreen v-model="isInProgDepMode" v-if="isInProgDepMode" persistent :max-width="$vuetify.breakpoint.name == 'md' ? '100%' : '80%'">
      <ProgDepartment />
    </v-dialog>

    <v-dialog v-model="isInProgClientsMode" v-if="isInProgClientsMode" persistent>
      <ProgClients />
    </v-dialog>

    <v-dialog v-model="isInMonthlyReportMode" v-if="isInMonthlyReportMode" persistent :max-width="isOnMobile ? '320px' : '380px'">
      <MonthlyRep />
    </v-dialog>

    <v-app-bar app clipped-right clipped-left dense class="pa-0 ma-0 elevation-7" style="top: 1px">
      <v-toolbar-items>
        <!-- <v-btn text @click="fp.addMode(Const.Modes.Sales)" :small="isOnMobile">
          <v-icon color="#1685c9" :left="!isOnMobile">mdi-cart-outline</v-icon>
          {{ isOnMobile ? "" : "Продажби" }}
        </v-btn>
        <v-divider vertical />-->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text @click="openTremolSite()" :small="isOnMobile">
              <v-avatar size="36px">
                <img :src="tremolLogo" />
              </v-avatar>
              {{ isOnMobile ? "" : "Tremol Echo" }}
            </v-btn>
          </template>
          <span>Информация за Tremol Echo</span>
        </v-tooltip>
        <v-divider vertical />

        <v-tooltip bottom v-if="fp.isConnectedToServer && fp.isConnectedToDevice">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text @click="fp.addMode(Const.Modes.Operations)" :small="isOnMobile">
              <v-icon color="#1685c9" size="26" :left="!isOnMobile">mdi-file-cog-outline</v-icon>
              {{ isOnMobile ? "" : "Операции" }}
            </v-btn>
          </template>
          <span>Въвеждане и извеждане на сума, отчети, диагностика</span>
        </v-tooltip>
        <v-divider vertical />
        <v-tooltip v-if="showFullScreenBtn" bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-if="showFullScreenBtn" v-on="on" text @click="requestFullScreen" :small="isOnMobile">
              <v-icon color="#1685c9" size="26" :left="!isOnMobile">{{ isOnFullScreen ? "mdi-arrow-collapse" : "mdi-arrow-expand-all" }}</v-icon>
              {{ isOnMobile ? "" : isOnFullScreen ? "Цял екран - изход" : "Цял екран" }}
            </v-btn>
          </template>
          <span>{{ isOnFullScreen ? 'Изход от режим "цял екран" ' : "Изглед на приложението на цял екран" }}</span>
        </v-tooltip>
        <v-divider v-if="showFullScreenBtn" vertical />
        <!-- <v-btn text @click="fp.addMode(Const.Modes.Status)" :small="isOnMobile">
          <v-icon color="#1685c9" :left="!isOnMobile">mdi-led-on</v-icon>
          {{ isOnMobile ? "" : "Статус" }}
        </v-btn>-->
      </v-toolbar-items>
      <v-spacer></v-spacer>

      <v-toolbar-items v-if="!isWindowNotWideEnough">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text @click="openAssistant()" :small="isOnMobile">
              <v-img :max-height="$vuetify.application.top" height="auto" class="mt-3" :width="isOnMobile ? 160 : 240" :src="tremolAssistantLogo"></v-img>
            </v-btn>
          </template>
          <span>Дистанционно отчитане на фискалното устройствo с Tremol Assistant</span>
        </v-tooltip>
      </v-toolbar-items>
      <v-spacer></v-spacer>

      <v-toolbar-items>
        <v-divider vertical />
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text @click="fp.addMode(Const.Modes.Settings)" :small="isOnMobile">
              <v-icon color="#1685c9" size="26" :left="!isOnMobile">mdi-cog-outline</v-icon>
              {{ isOnMobile ? "" : "Настройки" }}
            </v-btn>
          </template>
          <span>Функционални и интерфейсни настройки</span>
        </v-tooltip>
        <v-divider vertical />
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn text :small="isOnMobile" v-on="on" @click="fp.isConnectedToDevice = false">
              <v-avatar size="30px" :color="fp.isConnectedToDevice ? `` : `error`" rounded>
                <img :src="fp.Image == null ? fpIcon : fp.Image" />
              </v-avatar>
              <!-- <span v-if="!isOnMobile" class="ml-2">ФУ</span> -->
              <v-progress-circular v-if="fp.isSearchingForDevice" :size="16" indeterminate></v-progress-circular>
            </v-btn>
          </template>
          <span>{{ showDeviceInfoIfConnected }}</span>
        </v-tooltip>
        <v-divider vertical />
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              :small="isOnMobile"
              v-on="on"
              @click="
                fp.isConnectedToServer = false;
                fp.isConnectedToDevice = false;
              "
            >
              <v-avatar size="28px" :color="fp.isConnectedToServer ? `` : `error`" rounded>
                <img :src="zfpLabServerIcon" />
              </v-avatar>
              <!-- <span v-if="!isOnMobile" class="v-btn__content ml-2">ZFPLabServer</span> -->
              <v-progress-circular v-if="fp.isSearchingForServer" :size="16" indeterminate></v-progress-circular>
            </v-btn>
          </template>
          <span>{{ fp.isConnectedToServer ? "ZFPLabServer " + fp.ZFPLabServerVersion + " на адрес: " + showServerAddressIfConnected : showServerAddressIfConnected }}</span>
        </v-tooltip>
      </v-toolbar-items>
    </v-app-bar>

    <v-main app>
      <div :style="`width: calc(100vw - ${menuWidth}px); height: calc(100% - ${headerFooterHeight}px); min-height: calc(100% - ${headerFooterHeight}px);`" class="maincontainer ma-0 pa-0" :class="$vuetify.theme.dark ? 'component-container-dark' : 'component-container-light'">
        <!-- <div :style="`background-size: 100%; backgroundImage: url(${image}); width: calc(100vw - ${menuWidth}px); height: calc(100% - ${headerFooterHeight}px); min-height: calc(100% - ${headerFooterHeight}px);`" class="maincontainer ma-0 pa-0" :class="$vuetify.theme.dark ? 'component-container-dark' : 'component-container-light'"> -->
        <v-container fill-height fluid class="ma-0 pa-0">
          <v-row v-if="!fp.isConnectedToServer" justify="center" align="start">
            <v-col>
              <v-row justify="center" align="center" class="ma-1">
                <span :class="isOnMobile ? 'infotext' : ''">За работа с приложението е необходима връзка със ZFPLabServer</span>
              </v-row>
              <v-row justify="center" align="start" class="ma-1">
                <a v-if="isOnMobile" href="https://play.google.com/store/apps/details?id=com.tremol.zfplabserver">Може да бъде изтеглен от тук</a>
                <a v-else :href="`${publicPath}ZFPLabServerSetup.exe`">Може да бъде изтеглен от тук</a>
              </v-row>
              <v-row justify="center" align="start" class="ma-1">
                <span :class="isOnMobile ? 'infotext' : ''">След като инсталирате успешно ZFPLabServer, натиснете бутон Свързване</span>
              </v-row>
              <v-row justify="center" align="start">
                <ConnectToZFPLabServer />
              </v-row>
            </v-col>
          </v-row>
          <v-row v-if="fp.isConnectedToServer && !fp.isConnectedToDevice" justify="center" align="start">
            <v-col>
              <v-row justify="center" align="center" class="ma-1">
                <span :class="isOnMobile ? 'infotext' : ''">За връзка с ФУ е необходимо то да бъде конфигурирано предварително.</span>
              </v-row>
              <v-row justify="center" align="center" class="ma-1">
                <span :class="isOnMobile ? 'infotext' : ''">Ако ФУ е касов апарат, Параметър 11 (Фискален принтер) трябва да е настроен на "ДА" и да е в режим "Продажби".</span>
              </v-row>
              <v-row v-if="!isOnMobile" justify="center" align="center" class="ma-1">
                <span :class="isOnMobile ? 'infotext' : ''">
                  За комуникация по USB, трябва да се инсталира съответния драйвер за
                  <a href="https://tremol.bg/bg/download/en.stsw-stm32102.zip">нови модели</a> или за <a href="https://tremol.bg/bg/download/USBDrv_TREMOL.zip">KL модели</a>.
                </span>
              </v-row>
              <v-row justify="center" align="center" class="ma-1">
                <span :class="isOnMobile ? 'infotext' : ''">За LAN/WIFI комуникация, трябва да се настрои "автоматично стартиране".</span>
              </v-row>
              <v-row justify="center" align="center">
                <ConnectToDevice />
              </v-row>
            </v-col>
          </v-row>

          <Sale v-if="isInSalesMode" justify="center" align="center" />
          <!-- <Operations v-if="isInOperationsMode" justify="center" align="center" /> -->
          <!--  <Settings v-if="isInSettingsMode" justify="center" align="center" /> -->
        </v-container>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import Const from "./constants";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import ConnectToZFPLabServer from "./components/ConnectToZFPLabServer";
import ConnectToDevice from "./components/ConnectToDevice";
import ErrorComponent from "./components/ErrorView.vue";
import Sale from "./components/SaleView.vue";
import Settings from "./components/SettingsView.vue";
import Operations from "./components/OperationsView";
import Status from "./components/StatusView.vue";
import ProgDateTime from "./components/ProgDateTime";
import QRScanner from "./components/QRScanner";
import MoneyInOut from "./components/MoneyInOut";
import ProgDepartment from "./components/ProgDepartment";
import ProgArticle from "./components/ProgArticle";
import ProgClients from "./components/ProgClients";
import MonthlyRep from "./components/MonthlyRep";
const image = require("../src/assets/img/bg.jpg");

if (!Date.prototype.getDateWithoutTime) {
  Date.prototype.getDateWithoutTime = function () {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate(), 0, 0, 0);
  };
}

export default {
  components: {
    ConnectToZFPLabServer,
    ConnectToDevice,
    ErrorComponent,
    Sale,
    Settings,
    Operations,
    Loading,
    Status,
    QRScanner,
    ProgDateTime,
    ProgDepartment,
    ProgArticle,
    ProgClients,
    MoneyInOut,
    MonthlyRep,
  },
  data() {
    return {
      image: image,
      Const: Const,
      isUrlInvalid: false,
      publicPath: process.env.BASE_URL,
      fpIcon: require("./assets/img/Tremol M20.png"),
      tremolLogo: require("./assets/img/tremolLogo.png"),
      tremolAssistantLogo: require("./assets/img/TremolAssistant.png"),
      zfpLabServerIcon: require("./assets/img/zfplabserver.png"),
    };
  },
  computed: {
    /** @return {Boolean} */
    isLoading() {
      return this.fp && this.fp.loadingMessage != null && this.fp.loadingMessage != false && this.fp.loadingMessage != "";
    },
    /** @return {Boolean} */
    isInSalesMode() {
      return this.fp && this.fp.isInMode(Const.Modes.Sales) && this.fp.isConnectedToDevice;
    },
    /** @return {Boolean} */
    isInProgClientsMode: {
      /** @return {Boolean} */
      get() {
        return this.fp && this.fp.isInMode(Const.Modes.ProgClients);
      },
      /** @return {Void} */
      set(value) {
        if (value) this.fp.addMode(Const.Modes.ProgClients);
        else this.fp.exitMode(Const.Modes.ProgClients);
      },
    },
    /** @return {Boolean} */
    isInMonthlyReportMode: {
      /** @return {Boolean} */
      get() {
        return this.fp && this.fp.isInMode(Const.Modes.MonthlyRep);
      },
      /** @return {Void} */
      set(value) {
        if (value) this.fp.addMode(Const.Modes.MonthlyRep);
        else this.fp.exitMode(Const.Modes.MonthlyRep);
      },
    },
    /** @return {Boolean} */
    isInProgArtMode: {
      /** @return {Boolean} */
      get() {
        return this.fp && this.fp.isInMode(Const.Modes.ProgramArticles);
      },
      /** @return {Void} */
      set(value) {
        if (value) this.fp.addMode(Const.Modes.ProgramArticles);
        else this.fp.exitMode(Const.Modes.ProgramArticles);
      },
    },
    /** @return {Boolean} */
    isInProgDepMode: {
      /** @return {Boolean} */
      get() {
        return this.fp && this.fp.isInMode(Const.Modes.ProgramDepartments);
      },
      /** @return {Void} */
      set(value) {
        if (value) this.fp.addMode(Const.Modes.ProgramDepartments);
        else this.fp.exitMode(Const.Modes.ProgramDepartments);
      },
    },
    /** @return {Boolean} */
    isInOperationsMode: {
      /** @return {Boolean} */
      get() {
        return this.fp && this.fp.isInMode(Const.Modes.Operations);
      },
      /** @return {Void} */
      set(value) {
        if (value) this.fp.addMode(Const.Modes.Operations);
        else this.fp.exitMode(Const.Modes.Operations);
      },
    },
    /** @return {Boolean} */
    isInSettingsMode: {
      /** @return {Boolean} */
      get() {
        return this.fp && this.fp.isInMode(Const.Modes.Settings);
      },
      /** @return {Void} */
      set(value) {
        if (value) this.fp.addMode(Const.Modes.Settings);
        else this.fp.exitMode(Const.Modes.Settings);
      },
    },
    /** @return {Boolean} */
    isInStatusMode: {
      /** @return {Boolean} */
      get() {
        return this.fp && this.fp.isInMode(Const.Modes.Status);
      },
      /** @return {Void} */
      set(value) {
        if (value) this.fp.addMode(Const.Modes.Status);
        else this.fp.exitMode(Const.Modes.Status);
      },
    },
    /** @return {Boolean} */
    isInDateTimeMode: {
      /** @return {Boolean} */
      get() {
        return this.fp && this.fp.isInMode(Const.Modes.SetDateTime);
      },
      /** @return {Void} */
      set(value) {
        if (value) this.fp.addMode(Const.Modes.SetDateTime);
        else this.fp.exitMode(Const.Modes.SetDateTime);
      },
    },

    /** @return {Boolean} */
    isInQrScanMode: {
      /** @return {Boolean} */
      get() {
        return this.fp && this.fp.isInMode(Const.Modes.QRScanner);
      },
      /** @return {Void} */
      set(value) {
        if (value) this.fp.addMode(Const.Modes.QRScanner);
        else this.fp.exitMode(Const.Modes.QRScanner);
      },
    },
    /** @return {Boolean} */
    isInMoneyInOutMode: {
      /** @return {Boolean} */
      get() {
        return this.fp && this.fp.isInMode(Const.Modes.MoneyInOut);
      },
      /** @return {Void} */
      set(value) {
        if (value) this.fp.addMode(Const.Modes.MoneyInOut);
        else this.fp.exitMode(Const.Modes.MoneyInOut);
      },
    },
    /** @return {String} */
    showServerAddressIfConnected() {
      return this.fp && this.fp.isConnectedToServer ? localStorage.getItem(Const.ZFPLabServerAddress) : "Не е установена връзка със ZFPLabServer!";
    },
    /** @return {String} */
    showDeviceInfoIfConnected() {
      if (this.fp && this.fp.isConnectedToDevice) {
        let isOnCOM = localStorage.getItem(Const.DeviceIsWorkingOnSerialPort);
        if (isOnCOM == "true") {
          return this.fp.serialNumber + " (" + this.fp.model + `) на ${localStorage.getItem(Const.DeviceSerialPortName)}, скорост ${localStorage.getItem(Const.DeviceBaudRate)}`;
        } else {
          return this.fp.serialNumber + " (" + this.fp.model + `) на IP адрес ${localStorage.getItem(Const.DeviceIPAddress)}`;
        }
      } else {
        return `Фискалното устройство не е свързано!`;
      }
    },
    /** @return {Boolean} */
    showFullScreenBtn() {
      return this.uiSettings.noFullScreen != true;
    },
  },
  methods: {
    openTremolSite() {
      window.open("https://tremol.bg/bg/product/tremol-echo", "_blank");
    },
    openAssistant() {
      //window.open("https://localhost:8080/TEST/landing", "_blank");
      window.open("https://a.tremol.bg/", "_blank");
    },
    exitScannerMode() {
      this.fp.exitMode(Const.Modes.QRScanner);
    },
    hideError() {
      this.fp.exitMode(Const.Modes.Error);
      this.fp.setErrorMessage(null);
    },
    async connect() {
      this.fp.isSearchingForServer = true;
      if (localStorage.getItem(Const.ZFPLabServerAddress) == null) {
        localStorage.setItem(Const.ZFPLabServerAddress, "http://localhost:4444/");
      }
      this.fp.ServerSetSettings(localStorage.getItem(Const.ZFPLabServerAddress));
      setTimeout(async () => {
        try {
          var err = await this.fp.checkServerVersionGetError();
          if (err != null) {
            this.fp.isSearchingForServer = false;
            this.fp.setErrorMessage(err);
            return;
          }
          this.fp.isConnectedToServer = true;
          if (localStorage.getItem(Const.DeviceIsWorkingOnSerialPort) != undefined) {
            this.fp.isSearchingForDevice = true;
            setTimeout(async () => {
              try {
                await this.fp.connect();
              } catch (exx) {
                this.fp.handleException(exx);
              }
            }, 1000);
          }
        } catch (ex) {
          this.fp.isConnectedToServer = false;
        }
        this.fp.isSearchingForServer = false;
      }, 1000);
    },
  },
  created() {},
  async mounted() {
    if (this.$route.query.sts) {
      localStorage.setItem(Const.DeviceSerialPortName, "STS");
    }

    this.$vuetify.theme.dark = localStorage.getItem(Const.Theme) == "true";
    //this.isUrlInvalid = window.location.search != "?" + ((+new Date().getDateWithoutTime()).toString(36) + new Date().getMonth());
    if (!this.isUrlInvalid) {
      this.$nextTick(() => {
        this.connect();
      });
    }
  },
  beforeDestroy() {},
};
</script>

<style>
html {
  overflow: hidden;
}

body {
  position: fixed;
  height: 100%;
  overflow: hidden;
}

.maincontainer {
  position: fixed;
  overflow: hidden;
}
.v-toolbar__content {
  padding: 0;
}
.vld-icon {
  text-align: center;
}

.button-span {
  text-align: left;
  text-align: start;
  width: 90%;
}

@media only screen and (min-width: 960px) {
  .button-span {
    width: 60%;
  }
}

@media only screen and (min-width: 1264px) {
  .button-span {
    width: 90%;
  }
}

.centered-input,
.centered-input input {
  text-align: center;
}

.centered-input label,
.centered-input .v-input__control .v-input__slot .v-text-field__slot .v-label--active {
  text-align: center;
  min-width: 100%;
  width: 100%;
}

.centered-input .v-input__control .v-input__slot .v-text-field__slot .v-label {
  position: relative;
}

.centered-input .v-select__selection {
  width: 100%;
  justify-content: center;
  text-align: center;
}

.centered-input input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}

.centered-input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}

.centered-input input::-webkit-outer-spin-button,
.centered-input input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: textfield;
  display: none;
  margin: 0;
}

.centered-input::-webkit-outer-spin-button,
.centered-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}

.component-container-light {
  background-color: #fff;
  color: #000;
}

.component-container-dark {
  background-color: rgb(55, 55, 55);
  color: #fff;
}

.component-container-opacity-light {
  background-color: rgba(255, 255, 255, 200);
  color: #000;
}

.component-container-opacity-dark {
  background-color: rgba(55, 55, 55, 200);
  color: #fff;
}

.component-container-dark {
  background-color: rgb(55, 55, 55);
  color: #fff;
}

.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
}

.fade-enter-active {
  transition-delay: 0.25s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
* {
  text-transform: none !important;
}

.light .v-virtual-scroll,
.light .v-menu__content,
.light .customscroll {
  overflow-y: auto;
  scrollbar-color: #aaa #eee;
}
.dark .v-virtual-scroll,
.dark .v-menu__content,
.dark .customscroll {
  overflow-y: auto;
  scrollbar-color: #111 #666;
}

.scrollbarlarge ::-webkit-scrollbar {
  /* width */
  width: 30px;
  height: 30px;
}

.scrollbarnormal ::-webkit-scrollbar {
  /* width */
  width: 12px;
  height: 12px;
}

/* button */
/* .light ::-webkit-scrollbar-button {
    background: #555;
} */
.light ::-webkit-scrollbar-thumb {
  /* Handle */
  background: #888;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgb(119, 119, 119);
  box-shadow: inset 0 0 6px rgb(119, 119, 119);
}
.light ::-webkit-scrollbar-thumb:hover {
  /* Handle on hover */
  background: #999;
}
.light ::-webkit-scrollbar-corner {
  /* Corner */
  background: #aaa;
}
.light ::-webkit-resizer {
  /* Resizer */
  background: #aaa;
}
.light ::-webkit-scrollbar-track {
  /* Track */
  background: #ddd;
}
/* The track NOT covered by the handle.
::-webkit-scrollbar-track-piece {
    background: #000;
} */

/* button */
/* .dark ::-webkit-scrollbar-button {
    background: #444; 
}*/

.dark ::-webkit-scrollbar-thumb {
  /* Handle */
  background: #666;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(51, 51, 51, 0.5);
  box-shadow: inset 0 0 6px rgba(51, 51, 51, 0.5);
}
.dark ::-webkit-scrollbar-thumb:hover {
  /* Handle on hover */
  background: #555;
}
.dark ::-webkit-scrollbar-corner {
  /* Corner */
  background: #888;
}
.dark ::-webkit-resizer {
  /* Resizer */
  background: #888;
}
.dark ::-webkit-scrollbar-track {
  /* Track */
  background: #888;
}
/* The track NOT covered by the handle.
::-webkit-scrollbar-track-piece {
    background: #000;
} */

.box-container {
  display: flex;
  overflow: hidden;
  flex-flow: column;
  height: 100%;
}

.box-container-horizontal {
  display: flex;
  overflow: hidden;
  flex-flow: row;
  width: 100%;
}

.box-container .row-header,
.box-container-horizontal .row-header {
  flex: 0 1 auto;
  overflow-y: none;
}

.box-container .row-content,
.box-container-horizontal .row-content {
  flex: 1 1 auto;
  overflow-y: auto;
}

.box-container .row-content-limited,
.box-container-horizontal .row-content-limited {
  flex: 1 1 100;
  overflow-y: auto;
}

.box-container .row-content-horizontal-scroll {
  flex: 1 1 auto;
  height: 100%;
  min-height: 100%;
  max-height: 100%;
  overflow-x: auto;
  overflow-y: none;
}
</style>
<style scoped>
.infotext {
  font-size: 14px;
}
.mySwitchClass >>> label,
.mySwitchClass >>> input {
  font-size: 12px;
}

/* Medium devices (landscape tablets, 768px and up) */
/* Extra large devices (large laptops and desktops, 1200px and up) */
/* Large devices (laptops/desktops, 992px and up) */

tr.strikeout td {
  position: relative;
} /* Setup a new coordinate system   */
tr.strikeout td:before {
  /* Create a new element that       */
  content: " "; /* …has no text content            */
  position: absolute; /* …is absolutely positioned       */
  left: 0;
  top: 50%;
  width: 100%; /* …with the top across the middle */
  border-bottom: 1px solid gray; /* …and with a border on the top   */
}
</style>
